<template>
  <div class="goods-list">
    <div v-for="packageGoodsInfo in packageGoods"
         v-bind:key="packageGoodsInfo.id"
         class="goods-item">
      <div v-if="packageGoodsInfo.goods_group.length > 0">
        <div class="tle_table_sub1">


          <v-popover
              v-if="packageGoodsInfo.goods_composition[0].display_info"
              trigger="hover"
              placement="right"
          >
            <span class="select-wrapper hw-input-wrap" style="display:inline-block">
                <select class="hw-input goods-select"
                        v-model="localSelectGoodsId"
                >
                    <option v-for="goodsGroupInfo in packageGoodsInfo.goods_group" :value="goodsGroupInfo.goods_id"
                            :key="goodsGroupInfo.goods_id">
                    {{goodsGroupInfo.expose_name}}
                    </option>
                </select>
            </span>
            <span style="" class="tooltip-icon">*</span>
        
            <template slot="popover">
              <div class="info-tooltip hw-rwd-layer layer-popover-test" style="width: 500px;">
                <div class="d-flex flex-column / h-100">
                  {{ packageGoodsInfo.goods_composition[0].display_info.data }}
                </div>
              </div>
            </template>
          </v-popover>
      
          <span v-else>
            <span class="select-wrapper hw-input-wrap">
            <select class="hw-input goods-select"
                    v-model="localSelectGoodsId"
            >
                <option v-for="goodsGroupInfo in packageGoodsInfo.goods_group" :value="goodsGroupInfo.goods_id"
                        :key="goodsGroupInfo.goods_id">
                    {{goodsGroupInfo.expose_name}}
                </option>
            </select>
            </span>
          </span>           
          
        </div>
        <table class="table_row_pay is__in-table">
          <colgroup><col class="w-40"><col></colgroup>
          <tbody>
              <tr v-for="resourceInfo in packageGoodsInfo.goods_info.resources" v-bind:key="resourceInfo.id">
                <th>{{resourceInfo.name}}</th>
                <td class="detail-color">{{ resourceInfo.volume }} {{ resourceInfo.volume_unit }}</td>
              </tr>
          </tbody>
        </table>
      </div>
      <table class="table_row_pay is__in-table" v-else>
        <colgroup><col class="w-40"><col></colgroup>
        <tbody >
          <tr>
            <th class="primary-color">
              
              
              <v-popover
                  v-if="packageGoodsInfo.goods_composition[0].display_info"
                  trigger="hover"
                  placement="right"
              >
                <span>
                  <span>{{packageGoodsInfo.expose_name}}</span>
                  <span class="tooltip-icon">*</span>
                </span>

                <template slot="popover">
                  <div class="info-tooltip hw-rwd-layer layer-popover-test" style="width: 500px;">
                    <div class="d-flex flex-column / h-100">
                      {{ packageGoodsInfo.goods_composition[0].display_info.data }}
                    </div>
                  </div>
                </template>
              </v-popover>
              
              <span v-else>{{packageGoodsInfo.expose_name}}</span>
              
              
            </th>
            <td></td>
          </tr>
          <tr v-for="resourceInfo in packageGoodsInfo.goods_info.resources" v-bind:key="resourceInfo.id">
            <th>{{resourceInfo.name}}</th>
            <td class="detail-color">
              <span v-if="resourceInfo.volume_unit !== '제공' ">{{ resourceInfo.volume }}</span>
              <span>{{ resourceInfo.volume_unit }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "GoodsDetailTable",
  props:{
    selectGoodsId : {
      type : Number
    }
  },
  computed: {
    ...mapState({
      packageGoods: state => state['goods_info']['package_goods'],
    }),
    localSelectGoodsId:{
      get () {return this.selectGoodsId},
      set (selectGoodsId) {this.$emit('change-select-goods', selectGoodsId)}
    }
  },
  watch : {
    packageGoods(packageGoods){
      if(!this.selectGoodsId){  // selectGoodsId가 없을 경우 기본값을 설정하는 로직 시작
        let findGroupPackagrGoods = packageGoods.find((packageGoodsInfo)=>{
          return packageGoodsInfo['goods_group'].length > 0
        })
        
        if(findGroupPackagrGoods){  // findGroupPackagrGoods가 있을 경우에만 기본값 설정 로직 시작
          let defaultSelectGoodsId =
              parseInt(findGroupPackagrGoods['goods_group'][0]['goods_id'])

          this.$emit('change-select-goods', defaultSelectGoodsId)
        }
      }
    }
  }
}
</script>

<style scoped>
.goods-list .goods-item{
  border-top: 1px solid #e5e5e5;
  padding-top:25px;
  margin-top:20px;
}
.goods-list .goods-item:first-child{
  border-top: none;
  padding-top:0;
  margin-top:0;
}
.info-tooltip{
  padding:5px;
}
.tooltip-icon{
  color:#e8171a;
  font-weight: normal;
}
.goods-select{
  width:250px;
}
.select-wrapper{
  display: inline-block;
}
</style>